import {Text} from '@rdcomponents/text/text';
import {Button, Popover} from 'antd';

import {useDocumentationLinks} from '../../../../../../../provider/help-links/help-links-hook';
import {Locale} from '../../../../../../../provider/locale/localization';
import {CatalogPriorityPlacementEnum} from '../../../../../../../service/reivew-analysis/rating-dynamics/reviews-analytics-ratings-dynamic-type';
import {classNames} from '../../../../../../../util/css';

import WgisPriorityPlacementMarkerGray from './images/wgis-priority-placement-gray.svg';
import WgisPriorityPlacementMarker from './images/wgis-priority-placement-marker.svg';
import {
    priorityStatusMarkPopoverContentLangKey,
    priorityStatusMarkPopoverTitleLangKey,
} from './wgis-priority-placement-mark-helper';
import * as styles from './wgis-priority-placement-mark.scss';

type PropsType = {
    priorityPlacement?: CatalogPriorityPlacementEnum;
};

export function WgisPriorityPlacementMark(props: PropsType): JSX.Element | null {
    const {priorityPlacement} = props;

    const documentationLinks = useDocumentationLinks();

    const documentationLink = documentationLinks.reviews.wgisRatingPriorityPlacement;

    // eslint-disable-next-line no-undefined
    if (priorityPlacement === null || priorityPlacement === undefined) {
        return null;
    }

    return (
        <Popover
            className={styles.WgisPriorityPlacementMark_popoverContent}
            content={
                <div className={styles.WgisPriorityPlacementMark_popoverContent}>
                    <Text block stringKey={priorityStatusMarkPopoverContentLangKey[priorityPlacement]} />
                    {documentationLink ? (
                        <Button
                            className={styles.WgisPriorityPlacementMark_popoverLink}
                            href={documentationLink}
                            target="_blank"
                            type="link"
                        >
                            <Locale stringKey="TEXT__MORE_DETAILS" />
                        </Button>
                    ) : null}
                </div>
            }
            title={
                <Text
                    block
                    bolder
                    className={styles.WgisPriorityPlacementMark_popoverTitle}
                    stringKey={priorityStatusMarkPopoverTitleLangKey[priorityPlacement]}
                />
            }
        >
            <div
                className={classNames(styles.WgisPriorityPlacementMark, {
                    [styles.WgisPriorityPlacementMark__actualized]:
                        priorityPlacement === CatalogPriorityPlacementEnum.PriorityPlacement,
                    [styles.WgisPriorityPlacementMark__notActualized]:
                        priorityPlacement === CatalogPriorityPlacementEnum.NotPriorityPlacement,
                })}
            >
                <img
                    alt="marker"
                    src={
                        priorityPlacement === CatalogPriorityPlacementEnum.PriorityPlacement
                            ? WgisPriorityPlacementMarker
                            : WgisPriorityPlacementMarkerGray
                    }
                />
            </div>
        </Popover>
    );
}
